import API from "../config/api.js";

export const SettingsService = {

    getCompanySettings() {
      return API.get(`api/settings/get-company-settings`);
    },
    getProjectSettings(){
      return API.get(`api/settings/get-project-settings`);
    },
    saveCompanySettings(data) {
      return API.post(`api/settings/company-settings`, data);
    },
    saveProjectSettings(data){
      return API.post(`api/settings/project-settings`, data);
    }

  
};